import EventDashboard from './EventDashboard.container';

export default EventDashboard;
